import * as React from "react";
function SvgLoading(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.556 3.685A9 9 0 0121 12h-2a7 7 0 10-3.5 6.062l1 1.732A9 9 0 118.556 3.685z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgLoading);
export default ForwardRef;
